import { StyleSheet } from 'aphrodite';
import { brandPrimaryText, gray4, grayIconFill, label, mention } from '../../../../../web/styles/colors';
import { THEME } from '../../../../../web/components-v2/Theme/theme';
import { CssSelectors, DefaultBorder } from '../../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	additionalInfo: {
		color: label,
		fontSize: THEME.typography.fontSizes.xs,
		marginLeft: THEME.spacing.sm,
		width: 200,
	},
	clickable: {
		cursor: 'pointer',
	},
	container: {
		marginBottom: THEME.spacing.xxxl,
		marginTop: THEME.spacing.xl,
		minHeight: 400,
		position: 'relative',
	},
	employeeList: {
		borderCollapse: 'collapse',
		borderWidth: 0,
		position: 'relative',
		tableLayout: 'fixed',
		width: '100%',
		...CssSelectors.allChildren(
			{
				width: '100%',
			},
			'tr'
		),
	},
	employeeListTableHead: {
		backgroundColor: THEME.colors.background.light,
		color: grayIconFill,
		fontSize: THEME.typography.fontSizes.xs,
		marginBottom: THEME.spacing.sm,
		padding: `${THEME.spacing.sm}px 0`,
		paddingRight: THEME.spacing.sm,
	},
	employeeListTableHeader: {
		background: THEME.colors.background.light,
		fontWeight: 'normal',
		marginRight: THEME.spacing.xl,
		paddingBottom: THEME.spacing.xl,
		textAlign: 'center',
		top: 0,
		zIndex: 1,
	},
	employeeListTableHeadName: {
		align: 'right',
		minWidth: 300,
		paddingBottom: THEME.spacing.xl,
		position: 'sticky',
		top: 0,
		width: '25%',
	},
	employeeListTableHeadShrink: {
		overflow: 'visible',
		position: 'sticky',
		textOverflow: 'allow',
		width: 35,
	},
	inviteButton: {
		alignItems: 'center',
		background: mention,
		borderRadius: 18,
		color: brandPrimaryText,
		display: 'flex',
		fontSize: THEME.typography.fontSizes.sm,
		height: 35,
		marginLeft: THEME.spacing.lg,
		width: 138,
	},
	menu: {
		background: THEME.colors.background.light,
		border: DefaultBorder,
		boxShadow: '0 2px 4px 0 rgba(0, 0, 0, .1)',
		minWidth: 200,
	},
	menuItem: {
		':hover': {
			background: '#77777777',
		},
		cursor: 'pointer',
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: 'normal',
		overflow: 'hidden',
		padding: `${THEME.spacing.md}px ${THEME.spacing.lg}px`,
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
	noDecoration: {
		color: THEME.colors.text.main,
		textDecoration: 'none',
	},
	refreshIcon: {
		height: 30,
		marginTop: THEME.spacing.xs,
		width: 30,
	},
	unsupportedISP: {
		marginBottom: THEME.spacing.sm,
		maxWidth: 600,
	},
	userNameDropdown: {
		width: '100%',
	},
	errorContainer: {
		marginBottom: THEME.spacing.md,
	},
	loadingContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		padding: THEME.spacing.lg,
	},
	paginationControls: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.md,
		justifyContent: 'center',
		marginTop: THEME.spacing.md,
		paddingBottom: THEME.spacing.sm,
	},
	pageInfo: {
		color: gray4,
		fontSize: THEME.typography.fontSizes.sm,
	},
	retryButton: {
		marginLeft: THEME.spacing.sm,
	},
});
